/* eslint-disable no-unused-vars */
import React, {useState} from 'react';
import Card from '@material-ui/core/Card';
import '../css/ProductsPage.css';
// import {AiFillDownCircle, AiFillUpCircle} from 'react-icons/ai';

/**
 * This function renders the Products page
 * @component AIPage
 * @return {Component} ProductsPage component
 */
export default function ProductsPage() {
  const [isActiveGeneral, setIsActiveGeneral] = useState(true);
  const [isActiveMaster, setIsActiveMaster] = useState(true);
  const [isActiveSpecial, setIsActiveSpecial] = useState(true);

  const research = [
    {name: 'General Consultation', ref: '06032021001'},
    {name: 'Industry Therapy Sessions', ref: '06012022001'},
    {name: 'Training Modules', ref: '06012022002'},
  ];

  const master = [
    {name: 'Principles of Metabolic Physics (500 pgs.)', ref: '08112020004'},
    {name: 'Advanced Metabolic Physics (500 pgs.)', ref: '08112020001'},
    {
      name: 'Metabolic Physics Warfare, Tactics (500 pgs.)',
      ref: '08112020005',
    },
    {name: 'Anti-Point Inversion (350 pgs.)', ref: '08112020013'},
    {
      name:
        'Metabolic Physics Communications Human Interface Devices ' +
        '(500 pgs.)',
      ref: '08112020003',
    },
    {
      name:
        'Adverse Health Effects from the Prolonged Use of Human Interface' +
        ' Devices (500 pgs.)',
      ref: '08112020017',
    },
  ];

  const special = [
    {
      name: 'Optitronics and Light-based Algorithmic Storage',
      ref: '08112020006',
    },
    {
      name: 'Artificial Intelligence Versus Artificially Incepted Life',
      ref: '06012022001',
    },
    {name: 'Holographic Neurons', ref: '08112020008'},
    {
      name:
        'Multi-Circa Metabolic Physics Information Relay Servers and ' +
        'Neural Capacitors',
      ref: '08112020009',
    },
    {
      name:
        'The Optitronic System Information Repository and Integrated ' +
        'Server (OSIRIS)',
      ref: '08112020007',
    },
    {
      name: 'The Terraformed Reactive Universal Locator Yield (TRULY)',
      ref: '08112020014',
    },
    {
      name: 'Space-based Operations Platform & Orbital Lab Development',
      ref: '08112020010 ',
    },
    {name: 'Intra-Geospatial Engineering', ref: '08112020011'},
    {name: 'Limited Physics Environments', ref: '08112020012'},
  ];

  return (
    <>
      <div className="product-root">
        <Card className="product-container">
          <h1>2022 Product Catalog</h1>
          <p style={{fontSize: '18px'}}>
            Choose a product or service to increase the success potential of
            existing developments, or select a project title to receive a free,
            no obligation quote to learn more about getting involved in existing
            projects with Advanced Intelligence Services products meant just for
            DoD, just for circa.
          </p>
          <form>
            <br />
            <div
              className="product-accordion"
              // onClick={() => setIsActiveGeneral(!isActiveGeneral)}
            >
              <h2>General Services&nbsp;</h2>
              <div>
                {/* {isActiveGeneral ? (
                  <AiFillUpCircle size={30} />
                ) : (
                  <AiFillDownCircle size={30} />
                )} */}
              </div>
            </div>
            {isActiveGeneral && (
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="80%">Product Title</th>
                    <th className="product-ref-cell">Reference Number</th>
                    <th className="select-cell" style={{textAlign: 'center'}}>
                      Select
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {research.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td data-label="Product Title">{data.name}</td>
                        <td
                          data-label="Reference Number"
                          className="product-ref-cell"
                        >
                          {data.ref}
                        </td>
                        <td
                          data-label="Select"
                          className="select-cell"
                          style={{textAlign: 'center'}}
                        >
                          <input type="checkbox" onChange={() => {}} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <br />
            <div
              className="product-accordion"
              // onClick={() => setIsActiveMaster(!isActiveMaster)}
            >
              <h2>Research Reports&nbsp;</h2>
              <div>
                {/* {isActiveMaster ? (
                  <AiFillUpCircle size={30} />
                ) : (
                  <AiFillDownCircle size={30} />
                )} */}
              </div>
            </div>
            {isActiveMaster && (
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="80%">Product Title</th>
                    <th className="product-ref-cell">Reference Number</th>
                    <th className="select-cell" style={{textAlign: 'center'}}>
                      Select
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {master.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td data-label="Product Title">{data.name}</td>
                        <td
                          data-label="Reference Number"
                          className="product-ref-cell"
                        >
                          {data.ref}
                        </td>
                        <td
                          data-label="Select"
                          className="select-cell"
                          style={{textAlign: 'center'}}
                        >
                          <input type="checkbox" />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            <br />
            <div
              className="product-accordion"
              // onClick={() => setIsActiveSpecial(!isActiveSpecial)}
            >
              <h2>Special Projects&nbsp;</h2>
              <div>
                {/* {isActiveSpecial ? (
                  <AiFillUpCircle size={30} />
                ) : (
                  <AiFillDownCircle size={30} />
                )} */}
              </div>
            </div>
            {isActiveSpecial && (
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="80%">Product Title</th>
                    <th className="product-ref-cell">Reference Number</th>
                    <th className="select-cell" style={{textAlign: 'center'}}>
                      Select
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {special.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td data-label="Product Title">{data.name}</td>
                        <td
                          data-label="Reference Number"
                          className="product-ref-cell"
                        >
                          {data.ref}
                        </td>
                        <td
                          data-label="Select"
                          className="select-cell"
                          style={{textAlign: 'center'}}
                        >
                          <input type="checkbox" onChange={() => {}} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <br />
            <div className="product-button-block">
              <br />
              <button type="button" className="product-submit">
                Continue
              </button>
            </div>
          </form>
        </Card>
      </div>
      <div style={{height: '200px'}}></div>
    </>
  );
}
